// Client pre-check for the two refusals deleteWorkspaceCallable enforces
// (D-20, D-21). UX only: the server stays authoritative and re-checks both.

// Mirrors LIVE_BILLING_STATUSES in functions/accountCascade.js. Keep in step.
export const LIVE_BILLING_STATUSES = ['trialing', 'active', 'past_due', 'unpaid', 'incomplete'];

export const REASON_ACTIVE_SUBSCRIPTION = 'active_subscription';
export const REASON_HAS_TEAM_AGENTS = 'has_team_agent_workspaces';

export function deleteBlockers({ workspace, workspaces } = {}) {
    const reasons = [];
    let childWorkspaces = [];
    if (!workspace) return { reasons, childWorkspaces };

    if (LIVE_BILLING_STATUSES.includes(workspace?.billing?.subscriptionStatus)) {
        reasons.push(REASON_ACTIVE_SUBSCRIPTION);
    }
    // The workspace tier lives on teamRole ('team' parent, 'team_agent' child).
    if (workspace.teamRole === 'team') {
        childWorkspaces = (Array.isArray(workspaces) ? workspaces : [])
            .filter((w) => w?.teamRole === 'team_agent'
                && w.parentWorkspaceId === workspace.id
                && w.status !== 'purging'
                && w.status !== 'deleting')
            .map((w) => ({ id: w.id, name: w.name || '' }));
        if (childWorkspaces.length > 0) reasons.push(REASON_HAS_TEAM_AGENTS);
    }
    return { reasons, childWorkspaces };
}

// "A", "A and B", "A, B, and C"; more than five names becomes "A, B, C, D, E, and N more".
export function joinChildNames(names) {
    const list = (names || []).filter(Boolean);
    const shown = list.slice(0, 5);
    const extra = list.length - shown.length;
    if (extra > 0) return `${shown.join(', ')}, and ${extra} more`;
    if (shown.length <= 1) return shown.join('');
    if (shown.length === 2) return `${shown[0]} and ${shown[1]}`;
    return `${shown.slice(0, -1).join(', ')}, and ${shown[shown.length - 1]}`;
}
